"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const browser_utils_1 = require("@walletconnect/browser-utils");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Header_1 = __importDefault(require("./Header"));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const QRCodeDisplay_1 = __importDefault(require("./QRCodeDisplay"));
const constants_1 = require("../constants");
function Modal(props) {
    const mobile = (0, browser_utils_1.isMobile)();
    const [loading, setLoading] = React.useState(false);
    const [fetched, setFetched] = React.useState(false);
    const [displayQRCode, setDisplayQRCode] = React.useState(!mobile);
    const [hasSingleLink, setHasSingleLink] = React.useState(false);
    const [singleLinkHref, setSingleLinkHref] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [links, setLinks] = React.useState([]);
    const displayProps = {
        mobile,
        text: props.text,
        uri: props.uri,
        qrcodeModalOptions: props.qrcodeModalOptions,
    };
    const getLinksIfNeeded = () => {
        React.useEffect(() => {
            const initLinks = () => __awaiter(this, void 0, void 0, function* () {
                if (fetched || loading || links.length > 0) {
                    return;
                }
                setLoading(true);
                try {
                    const url = props.qrcodeModalOptions && props.qrcodeModalOptions.registryUrl
                        ? props.qrcodeModalOptions.registryUrl
                        : (0, browser_utils_1.getWalletRegistryUrl)();
                    const registryResponse = yield fetch(url);
                    const registry = (yield registryResponse.json()).listings;
                    const platform = mobile ? 'mobile' : 'desktop';
                    const _links = (0, browser_utils_1.getMobileLinkRegistry)((0, browser_utils_1.formatMobileRegistry)(registry, platform), []);
                    setLoading(false);
                    setFetched(true);
                    setErrorMessage(!_links.length ? props.text.no_supported_wallets : '');
                    setLinks(_links);
                    const hasSingleLink = _links.length === 1;
                    if (hasSingleLink) {
                        setSingleLinkHref((0, browser_utils_1.formatIOSMobile)(props.uri, _links[0]));
                        setDisplayQRCode(true);
                    }
                    setHasSingleLink(hasSingleLink);
                }
                catch (e) {
                    setLoading(false);
                    setFetched(true);
                    setErrorMessage(props.text.something_went_wrong);
                    console.error(e); // eslint-disable-line no-console
                }
            });
            initLinks();
        });
    };
    getLinksIfNeeded();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: constants_1.KLIP_MODAL_ID, className: "klip-qrcode__base animated fadeIn" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "klip-modal__base" }, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, { onClose: props.onClose }), hasSingleLink && displayQRCode ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "klip-modal__single_wallet" }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ onClick: () => (0, browser_utils_1.saveMobileLinkInfo)({ name: links[0].name, href: singleLinkHref }), href: singleLinkHref, rel: "noopener noreferrer", target: "_blank" }, { children: props.text.connect_with + ' ' + (hasSingleLink ? links[0].name : '') + ' ›' })) }))) : null, displayQRCode || (!loading && !links.length) ? ((0, jsx_runtime_1.jsx)(QRCodeDisplay_1.default, Object.assign({}, displayProps))) : ((0, jsx_runtime_1.jsx)("div", { children: errorMessage }))] })) })));
}
exports.default = Modal;
